export class ScannerException extends Error {
  constructor(message?: string) {
    super(message);
    this.name = 'ScannerException';
  }
}
